export const STORAGE_KEY = 'VF-ZP';
export const SESSION_KEY = 'dsl-change';
